import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import AssignAgentFormComponent from './AssignAgentFormComponent';

import {
  createCallCenterAgent,
  deleteCallCenterAgent,
  getServiceUsers,
} from './actions';

import * as remoteDoormanSelectors from './selectors';

const form = 'AssignAgent';

const AssignAgentFormContainer = (props) => {
  const {
    onDeleteCallCenterAgent,
    ccAgentId,
    onCreateCallCenterAgent,
    getCallCenterAgentsList,
    onModalClose,
    initialValues,
  } = props;

  const onSubmit = async (data) => {
    // due to validation rules workerSid should be free
    const isDeleted = await onDeleteCallCenterAgent(ccAgentId);
    if (!isDeleted) return;
    // workerSid is free - assign new person
    const isCreated = await onCreateCallCenterAgent(data);
    // if new agent wasn't created - restore previous assignment
    if (!isCreated) await onCreateCallCenterAgent(initialValues);

    getCallCenterAgentsList();
    onModalClose();
  };

  return <AssignAgentFormComponent {...props} onSubmit={onSubmit} />;
};

AssignAgentFormContainer.defaultProps = {};

AssignAgentFormContainer.propTypes = {
  ccAgentId: PropTypes.number.isRequired,
  onDeleteCallCenterAgent: PropTypes.func.isRequired,
  onCreateCallCenterAgent: PropTypes.func.isRequired,
  getCallCenterAgentsList: PropTypes.func.isRequired,
  onModalClose: PropTypes.func.isRequired,
  initialValues: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = (state, { ccAgentData }) => {
  const serviceUsersOptions =
    remoteDoormanSelectors.getServiceUsersOptions(state);

  const { id: ccAgentId, person, name, workerSid } = ccAgentData;
  const initialValues = {
    person: person?.id,
    name,
    workerSid,
  };

  return {
    ccAgentId,
    serviceUsersOptions,
    initialValues,
    form,
  };
};

const mapDispatchToProps = (dispatch) => ({
  onLoad: () => getServiceUsers(dispatch),
  onDeleteCallCenterAgent: (agentId) =>
    deleteCallCenterAgent(dispatch, agentId),
  onCreateCallCenterAgent: (data) => createCallCenterAgent(dispatch, data),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AssignAgentFormContainer);
